<template>
  <Modal v-model="markShipmentModal" :title="markShipmentTitle" width="600" :transfer="false" class-name="commonModalStyle"
    :mask-closable="false" @on-visible-change="markShipmentChange">
    <template v-if="markShipmentType === 'supplierLogistics'">
      <div class="flex align-items-center mb20 pl30">
        <span>{{ $t('key1004010') }}</span>
        <span>{{ detailsInfo.merchantCarrierName + ' > ' + detailsInfo.merchantShippingMethodName }}</span>
      </div>
      <div class="flex align-items-center mb20 pl30">
        <span>{{ $t('key1006924') }}</span>
        <Input clearable v-model.trim="trackingNumber" class="width_250"></Input>
      </div>
    </template>
    <template v-else>
      <Form ref="markShipmentForm" :model="markShipmentForm" :rules="ruleValidate" :label-width="110" @submit.native.prevent>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004010')" prop="expressageCode">
            <Select v-model="markShipmentForm.expressageCode" filterable transfer class="width_300">
              <Option v-for="(item, index) in logisticsChannelsList" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004530')" prop="expressageNo">
            <Input clearable v-model.trim="markShipmentForm.expressageNo" class="width_300"></Input>
          </Form-item>
        </Col>
      </Form>
    </template>
    <template #footer>
      <Button @click="markShipmentModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="markShipmentBtn" :disabled="!trackingNumber&&markShipmentType==='supplierLogistics'">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'markShipmentModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      markShipmentModal: false,
      markShipmentTitle: '',
      markShipmentType: '',
      markShipmentForm: {
        expressageCode: null,
        expressageNo: '',
      },
      ruleValidate: {
        expressageCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004279'), trigger: 'change'}
        ],
        expressageNo: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006923'), trigger: 'blur'}
        ]
      },
      logisticsChannelsList: [],
      typeShippingList: [],
      trackingNumber: '',
      detailsInfo: {}
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initMarkShipmentData(type, obj) {
      let titleObj = {
        supplierLogistics: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001572'),
        thirdPartyLogistics: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004262')
      };
      this.markShipmentTitle = titleObj[type];
      this.markShipmentType = type;
      this.detailsInfo = obj;
      if (type === 'thirdPartyLogistics') {
        this.getExpressageHundredList();
      }
      this.markShipmentModal = true;
    },
    // 确定按钮
    markShipmentBtn() {
      let v = this;
      let query = {};
      let {
        isOwnShippingMethod, deliveryType, expressageCode, expressageNo,
        carrierId, shippingMethodId, packageId, trackingNumber
      } = v.detailsInfo;
      switch (v.markShipmentType) {
        // 标记发货
        case 'supplierLogistics':
          query = {
            carrierId: carrierId,
            deliveryType: deliveryType,
            expressageCode: expressageCode,
            expressageNo: expressageNo,
            isOwnCarrier: isOwnShippingMethod,
            packageIds: [packageId],
            shippingMethodId: shippingMethodId,
            trackingNumber: v.trackingNumber
          };
          markShipmentFun(query);
          break;
        // 国内快递选择
        case 'thirdPartyLogistics':
          v.$refs['markShipmentForm'].validate((valid) => {
            if (valid) {
              query = {
                carrierId: carrierId || null,
                deliveryType: deliveryType,
                expressageCode: v.markShipmentForm.expressageCode,
                expressageNo: v.markShipmentForm.expressageNo,
                isOwnCarrier: isOwnShippingMethod,
                packageIds: [packageId],
                shippingMethodId: shippingMethodId || null,
                trackingNumber: trackingNumber || null
              };
              markShipmentFun(query);
            }
          });
          break;
      }

      function markShipmentFun(query) {
        v.axios.post(api.post_packageInfo_shipmentDeliveryOrder, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.markShipmentModal = false;
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006890'));
            v.$emit('updateData', true);
          }
        });
      }
    },
    // 监听弹窗
    markShipmentChange(value) {
      if (!value) {
        this.detailsInfo = {};
        this.logisticsChannelsList = [];
        this.$refs['markShipmentForm']?.resetFields();
        this.trackingNumber = '';
      }
    },
    // 获取运输方式的数据
    getExpressageHundredList() {
      let v = this;
      v.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          v.logisticsChannelsList = response.data.datas;
        }
      });
    },
  },
};
</script>

<style lang="less">

</style>
